import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function QuantitySelectionModal({
  open,
  onClose,
  onSelectSameQuantities,
  onSelectDifferentQuantities,
  quantity,
}) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ p: 3 }}>
        <Typography
          align="center"
          color="textSecondary"
          sx={{ px: 2, fontWeight: 500, fontSize: 22 }}
        >
          Attention
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 16, top: 16 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" py={4}>
          <Typography
            color="textPrimary"
            align="center"
            sx={{
              mb: 6,
              maxWidth: 500,
              fontWeight: 500,
            }}
          >
            Will each location have the same quantity of {quantity} or will they have different
            quantities?
          </Typography>

          <Box display="flex" gap={2} width="100%" justifyContent="center">
            <Button
              variant="outlined"
              color="primary"
              size="large"
              sx={{
                minWidth: 200,
                py: 1.5,
                borderRadius: 2,
              }}
              onClick={onSelectDifferentQuantities}
            >
              Different Quantities
            </Button>

            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{
                minWidth: 200,
                py: 1.5,
                borderRadius: 2,
              }}
              onClick={onSelectSameQuantities}
            >
              Same Quantities
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
